





























import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../../dialogs/ZenyaDialog.vue";
import { Comment } from "@/documentComments";
import CommentIcon from "./CommentIcon.vue";
import { CommentState, CommentType } from "@/enums";
import storeHelper from "@/store/store-helper";
import { CommentReply } from "@/types/commentReply";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "RejectCommentReason",
    props: {
        comment: Object as () => Comment,
        replyCommenterCommentType: String as () => CommentType
    },
    components: {
        CommentIcon
    },
    data: () => {
        return {
            commentText: null
        };
    },
    computed: {
        requiredRule() {
            return [(v: string) => Boolean(v) || this.$t("general.validation.isRequired")];
        }
    },
    methods: {
        validateForm(): boolean {
            return (this.$refs.form as Vue & { validate: () => boolean }).validate();
        },
        async okClicked(): Promise<boolean> {
            if (this.validateForm()) {
                let commentReply: Partial<CommentReply> = {
                    is_reject_reason: true,
                    text: this.commentText,
                    comment_type: CommentType.Writer
                };

                const updateCommentStatePromise = storeHelper.documentStore.updateDocumentCommentState(
                    CommentState.Rejected,
                    this.comment.comment_id
                );
                const addCommentReplyPromise = storeHelper.documentStore.addCommentReplyAsync(this.comment.comment_id, commentReply as CommentReply);
                let [updateCommentStateResponse, addCommentReplyResponse] = await Promise.all([updateCommentStatePromise, addCommentReplyPromise]);

                this.$emit("comment-status-changed", updateCommentStateResponse.success);
                return true;
            }
            return false;
        },
        getCommentStatus(): string {
            switch (this.comment.state) {
                case "new":
                    return this.$t("comment.state.new") as string;
                case "accepted":
                    return this.$t("comment.state.accepted") as string;
                case "fixed":
                    return this.$t("comment.state.fixed") as string;
                case "rejected":
                    return this.$t("comment.state.rejected") as string;
                default:
                    return this.$t("comment.state.unknown") as string;
            }
        },
        getStateColor(): string {
            switch (this.comment.state) {
                case CommentState.Fixed:
                    return "green--text";
                case CommentState.Rejected:
                    return "red--text";
                case CommentState.Accepted:
                    return "blue--text";
                default:
                    return "grey--text";
            }
        }
    },
    created() {
        this.registerHandlers({ ok: this.okClicked });
    }
});
